// @ts-nocheck (BC)
import update from 'immutability-helper'
import { AddUserApiErrors } from '@feedyou/utils'

import * as actionTypes from '../constants/actionTypes'

const initialState = {
  loading: undefined,
  error: undefined,
  users: undefined
}

export function usersReducer(state = initialState, { type, payload }) {
  switch (type) {
    case actionTypes.GET_USERS:
      return { ...state, loading: true, error: undefined }

    case actionTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        users: payload.reduce((users, user) => {
          users[user.id] = user

          return users
        }, {}),
        loading: undefined
      }

    case actionTypes.GET_USERS_FAILURE:
      return { ...state, error: AddUserApiErrors.NotFoundUsers, loading: undefined }

    case actionTypes.ADD_USER_PLACEHOLDER:
      return { ...state, placeholder: {} }
    case actionTypes.RESET_USER_PLACEHOLDER:
      return { ...state, placeholder: undefined }

    case actionTypes.ADD_USER:
      return update(state, { placeholder: { loading: { $set: true }, error: { $set: undefined } } })

    case actionTypes.ADD_USER_SUCCESS:
      return update(state, {
        $unset: ['placeholder'],
        users: { [payload.id]: { $set: payload } }
      })

    case actionTypes.ADD_USER_FAILURE:
      return update(state, {
        placeholder: {
          loading: { $set: undefined },
          error: { $set: payload || AddUserApiErrors.AddUserFailure }
        }
      })

    case actionTypes.UPDATE_USER:
      return update(state, {
        users: { [payload.id]: { $merge: { ...payload, error: undefined } } }
      })

    case actionTypes.UPDATE_USER_FAILURE:
      return update(state, {
        users: { [payload]: { error: { $set: AddUserApiErrors.UpdateUserFailure } } }
      })

    case actionTypes.DELETE_USER:
      return update(state, {
        users: { [payload]: { deleting: { $set: true }, error: { $set: undefined } } }
      })

    case actionTypes.DELETE_USER_SUCCESS:
      return update(state, {
        users: { $unset: [payload] }
      })

    case actionTypes.DELETE_USER_FAILURE:
      return update(state, {
        users: {
          [payload]: {
            deleting: { set: undefined },
            error: { $set: AddUserApiErrors.DeleteUserFailure }
          }
        }
      })

    default:
      return state
  }
}
